import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as TimerIconSvg } from "../../../assets/icons/timer-solid.svg";

const IconTimer = (props: SvgIconProps) => (
  <SvgIcon
    component={TimerIconSvg}
    inheritViewBox
    {...props}
    sx={{ ...props.sx, padding: "2px", marginRight: "8px" }}
  />
);

export default IconTimer;
